import React, { FC, useEffect, useState } from "react";
import { v4 } from "uuid";
import { VbzTabBar, ItemListTabs } from "@smiles/voebiz-ui-kit";
import { FormGroup, TabContent, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";

import { useModal } from "../../hooks/useModal/index";

import InfoError from "../../components/InfoError/index";
import { Loading } from "../../components/Loading";
import { FilterBtn, FilterModal, FlightCard, FlightHistoryCard, ModalDetail } from "../../components";

import { TYPE_COMPONENT } from "../../constants";
import { IFlightOrder, ISegment } from "../../@types/flight-order";

const MyFlights: FC<{ type: string | null }> = ({ type }) => {
  const [typeComponent, setTypeComponent] = useState("not-simple");
  const [flightDetail, setFlightDetail] = useState<ISegment[]>();
  const {
    toggleDetail,
    toggleFilter,
    modal,
    setPeriod,
    dataFlightsList,
    setDataFlights,
    initialized,
    loading,
    defaultFutureFlights,
    defaultPastFlights,
    clearFlightsList,
  } = useModal();
  type Tabs = "tab1" | "tab2";
  const { t } = useTranslation("myFlights");
  const [activeTab, setActiveTab] = useState<Tabs>("tab1");

  const tabs: ItemListTabs[] = [
    {
      id: "tab1",
      key: "_tab1",
      label: "Próximos voos",
      href: "#",
      active: activeTab === "tab1",
      onClick: () => {
        setActiveTab("tab1");
        clearFlightsList("FUTURE");
        defaultFutureFlights();
      },
    },
    {
      id: "tab2",
      key: "_tab2",
      label: "Histórico",
      href: "#",
      active: activeTab === "tab2",
      onClick: () => {
        setActiveTab("tab2");
        clearFlightsList("PAST");
        defaultPastFlights();
      },
    },
  ];

  const renderFlightCards = (flightOrder: IFlightOrder[], typeComp: string) => {
    if (flightOrder[0].flight.passengerList && flightOrder[0].flight.passengerList.length > 0) {
      return flightOrder.map((order: IFlightOrder) =>
        order.flight.chosenFlightSegmentList.map((item: ISegment) => (
          <FlightCard
            key={v4()}
            type={typeComp}
            arrival={item.chosenFlight.arrival}
            departure={item.chosenFlight.departure}
            duration={item.chosenFlight.duration}
            stops={item.chosenFlight.stops}
            locator={item.recordLocator}
            changed={order.bookingStatus !== "CONFIRMED"}
            travelers={item.passengerList}
            onClickDetail={() => {
              setFlightDetail(order.flight.chosenFlightSegmentList);
              toggleDetail(true);
            }}
          />
        )),
      );
    }
    return <></>;
  };

  const renderFlightHistoryCards = (flightOrder: IFlightOrder[]) => {
    return flightOrder.map((order: IFlightOrder) =>
      order.flight.chosenFlightSegmentList.map((item: ISegment) => (
        <FlightHistoryCard
          key={v4()}
          arrival={item.chosenFlight.arrival}
          departure={item.chosenFlight.departure}
          locator={item.recordLocator}
          // changed={order.bookingStatus !== "CONFIRMED"}
          // não está vindo do serviço o bookingStatus no Past
          changed={false}
        />
      )),
    );
  };

  const renderInfoError = () => {
    if (loading) {
      return <Loading />;
    }
    return <InfoError typeComponent={typeComponent} />;
  };

  const handleCloseDetail = () => toggleDetail(false);
  const handleCloseFilter = () => toggleFilter(false);
  const handleOpenFilter = () => toggleFilter(true);

  useEffect(() => {
    setTypeComponent(type || "not-simple");
  }, [type]);

  const titles: { [key in PeriodFilters]: string } = {
    LAST_7_DAYS: t("last7Days"),
    LAST_15_DAYS: t("last15Days"),
    LAST_30_DAYS: t("last30Days"),
    NEXT_7_DAYS: t("next7Days"),
    NEXT_15_DAYS: t("next15Days"),
    NEXT_30_DAYS: "Próximos 30 dias",
    NO_INTERVAL: "",
    LOCATOR: t("locator"),
  };

  if (!initialized) {
    return <div />;
  }

  return (
    <section
      className={typeComponent === TYPE_COMPONENT ? "my-flights-section small-margin-bottom" : "my-flights-section"}
    >
      <h4 className="my-flights-section__title">{typeComponent === TYPE_COMPONENT && t("mainTitle")}</h4>
      <div className="my-flights-section__content">
        {/* Modal Detail Flights */}
        {typeComponent !== TYPE_COMPONENT && (
          <>
            <FormGroup>
              <VbzTabBar list={tabs} />
            </FormGroup>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="tab1" id="_tab1" className="tab" key={v4()}>
                <div className="my-flights__btns ">
                  <FilterBtn onClickHandler={handleOpenFilter} />
                </div>
                {dataFlightsList.length > 0 ? (
                  <>
                    <div className="my-flights__top">
                      <h4>{titles[modal.period as PeriodFilters]}</h4>
                    </div>
                    {renderFlightCards(dataFlightsList, typeComponent)}
                  </>
                ) : (
                  renderInfoError()
                )}
              </TabPane>

              <TabPane tabId="tab2" id="_tab2" className="tab" key={v4()}>
                <div className="my-flights__btns ">
                  <FilterBtn onClickHandler={handleOpenFilter} />
                </div>
                {dataFlightsList.length > 0 ? (
                  <>
                    <div className="my-flights__top">
                      <h4>{titles[modal.period as PeriodFilters]}</h4>
                    </div>
                    {renderFlightHistoryCards(dataFlightsList)}
                  </>
                ) : (
                  renderInfoError()
                )}
              </TabPane>
            </TabContent>
          </>
        )}
        {typeComponent === TYPE_COMPONENT && (
          <>{dataFlightsList.length > 0 ? renderFlightCards(dataFlightsList, typeComponent) : renderInfoError()}</>
        )}

        {typeComponent === TYPE_COMPONENT && dataFlightsList.length > 0 && (
          <div className="my-flights-section__content__all">
            <a className="my-flights-section__content__all__button" href="/minha-conta/meus-voos">
              Todos os voos
            </a>
          </div>
        )}
      </div>
      <ModalDetail
        isOpen={modal.isOpenDetail}
        handleClose={handleCloseDetail}
        onExit={handleCloseDetail}
        listFlight={flightDetail}
      />
      <FilterModal
        isOpen={modal.isOpenFilter}
        handleClose={handleCloseFilter}
        onExit={handleCloseFilter}
        setPeriod={setPeriod}
        filter={modal.filter}
        activeTab={activeTab}
        setDataFlights={setDataFlights}
      />
    </section>
  );
};

export default MyFlights;
